<template>
  <div class="activity-detail-page">
    <div class="alert" :class="{'success' :isEnd, 'warning': !isEnd}">
      <div class="countdown" v-if="!isEnd">
        <span>活动将在</span>
        <van-count-down @finish="activityTimeout" :time="endTime" format="DD 天 HH 时 mm 分 ss 秒" />
        <span>后结束</span>
      </div>
      <div v-else>
        <span v-if="detail.is_pay">活动已结束，奖金已发放</span>
        <span v-else>活动已结束，奖金发放中</span>
      </div>
    </div>
    <div class="info">
      <div class="title">
        <span>{{detail.title}}</span>
        <router-link class="rule" :to="{name: 'activity.rule', query: {id: detail.id}}">
          <van-icon name="question-o" />活动规则
        </router-link>
      </div>
      <div class="money">
        奖金池
        <span class="red">{{detail.money_award}}元</span>
      </div>
    </div>
    <div class="list">
      <div v-for="(item, index) in userList" :key="item.id" class="item shadow">
        <div class="index">{{index+1}}</div>
        <van-image fit="cover" round width="45" height="45" :src="item.avatar" />
        <div class="text">
          <div>{{(item.nick_name || item.username) | hideString}}</div>
        </div>
        <div class="todo">
          <div class="item-money">+{{item.award}}元</div>
          <div>{{text_left}} {{item.count || item.income_money}} {{text_right}}</div>
        </div>
      </div>
      <van-divider v-if="!userList.length">暂无用户入围</van-divider>
    </div>
  </div>
</template>
<script>
import {
  Tag,
  List,
  Cell,
  Image,
  Divider,
  CountDown,
  Icon,
} from 'vant';
import ActivityProxy from '@/proxies/activity';

export default {
  data() {
    return {
      userList: [],
      detail: {},
      endTime: 0,
      isEnd: false,
      rules: [],
      text_left: '',
      text_right: '',
      finished: false,
      loading: false,
      pageIndex: 1,
      now: new Date().getTime(),
    };
  },
  components: {
    [Tag.name]: Tag,
    [List.name]: List,
    [Cell.name]: Cell,
    [Image.name]: Image,
    [Divider.name]: Divider,
    [CountDown.name]: CountDown,
    [Icon.name]: Icon,
  },
  created() {
    this.getActivityDetail();
  },
  methods: {
    onLoad() {
      this.loading = true;
      setTimeout(() => {
        this.getActivityDetail();
      }, 500);
    },
    // 倒计时结束
    activityTimeout() {
      this.isEnd = true;
    },
    // 按任务完成数
    async getUsersByTask() {
      const params = {
        start_at: this.detail.start_at,
        end_at: this.detail.end_at,
        min: this.detail.min,
        user_count: this.rules.length,
      };
      const res = await ActivityProxy.getUsersByTask(params);
      if (res.success) {
        this.userList = res.data.map((item, index) => {
          item.award = this.rules[index].value;
          return item;
        });
      }
    },
    // 按用户邀请数
    async getUsersByInvite() {
      const params = {
        start_at: this.detail.start_at,
        end_at: this.detail.end_at,
        min: this.detail.min,
        user_count: this.rules.length,
      };
      const res = await ActivityProxy.getUsersByInvite(params);
      if (res.success) {
        this.userList = res.data.map((item, index) => {
          item.award = this.rules[index].value;
          return item;
        });
      }
    },
    // 按邀请奖励额
    async getUsersByInviteMoney() {
      const params = {
        start_at: this.detail.start_at,
        end_at: this.detail.end_at,
        min: this.detail.min,
        user_count: this.rules.length,
      };
      const res = await ActivityProxy.getUsersByInviteMoney(params);
      if (res.success) {
        this.userList = res.data.map((item, index) => {
          item.award = this.rules[index].value;
          return item;
        });
      }
    },
    // 按任务完成奖励额
    async getUsersByTaskMoney() {
      const params = {
        start_at: this.detail.start_at,
        end_at: this.detail.end_at,
        min: this.detail.min,
        user_count: this.rules.length,
      };
      const res = await ActivityProxy.getUsersByTaskMoney(params);
      if (res.success) {
        this.userList = res.data.map((item, index) => {
          item.award = this.rules[index].value;
          return item;
        });
      }
    },
    // 获取活动详情
    async getActivityDetail() {
      const params = {
        id: this.$route.query.id,
      };
      const res = await ActivityProxy.getActivityDetail(params);
      this.loading = false;
      if (res.success) {
        this.endTime = +res.data.end_at - new Date().getTime();
        this.isEnd = this.endTime < 0;
        this.rules = res.data.award_rule ? JSON.parse(res.data.award_rule) : [];
        this.detail = res.data;
        switch (Number(res.data.type)) {
          case 1:
            this.getUsersByTask();
            this.text_left = '完成了';
            this.text_right = '个任务';
            break;
          case 2:
            this.getUsersByInvite();
            this.text_left = '邀请了';
            this.text_right = '个用户';
            break;
          case 3:
            this.getUsersByInviteMoney();
            this.text_left = '获得了';
            this.text_right = '元奖励';
            break;
          case 4:
            this.getUsersByTaskMoney();
            this.text_left = '获得了';
            this.text_right = '元佣金';
            break;
          default:
            console.info(res.data.type);
            break;
        }
      }
    },
  },
};
</script>
<style lang="less">
.activity-detail-page {
  .list {
    padding: 0 10px;
  }
  .item {
    margin: 10px 0;
    padding: 10px;
    border-radius: 5px;
    -webkit-border-radius: 5px;
    -moz-border-radius: 5px;
    -ms-border-radius: 5px;
    -o-border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
  }
  .text {
    flex-grow: 1;
    margin-left: 10px;
  }
  .todo {
    color: gray;
    font-size: 12px;
  }
  .info {
    background-color: #fff;
    padding: 10px;
  }
  .countdown {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .van-count-down {
    color: #fff;
  }
  .money {
    text-align: center;
    font-size: 12px;
    margin: 10px 0;
    color: #666;
  }
  .red {
    color: #F56C6C;
    font-size: 36px;
    font-weight: bold;
  }
  .title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .index {
    width: 20px;
    margin-right: 8px;
    text-align: center;
    font-weight: bold;
    font-style: italic;
    color: #333;
  }
  .item-money {
    text-align: right;
    color: #F56C6C;
    font-size: 16px;
  }
  .alert {
    color: #fff;
    margin: 10px;
    border-radius: 2px;
    padding: 10px;
  }
  .success {
    background-color: #07c160;
  }
  .warning {
    background-color: #f90;
  }
  .rule {
    color: #999!important;
    display: flex;
    align-items: center;
    font-size: 12px;
  }
}
</style>
